import  axiosClient  from "../axiosClient";

export function coinsTimeout(data){
    let bearerTokenHeader = localStorage.getItem('token');
    axiosClient.defaults.headers.common['Authorization'] = `Bearer ${bearerTokenHeader}`;
    return axiosClient.post('/coins/timeout',JSON.stringify(data));
}